import React from 'react';
import SettingsForm from '../ui-kit/SettingsForm';

const Settings = ({ updateWidgetSettingsField, widgetSettings }) => (
  <SettingsForm
    updateWidgetSettingsField={updateWidgetSettingsField}
    widgetSettings={widgetSettings}
    withAutoResizeHeight={true}
    withAutoScroll={true}
  >
    <SettingsForm.Section>
      <SettingsForm.Section.Header>{I18n.t('display')}</SettingsForm.Section.Header>
      <SettingsForm.Section.Content>
        <SettingsForm.ToggleField
          fieldName="hideRejectedAndExpiredResponses"
          label={I18n.t('dashboards.widget_archetypes.crew_confirmations.settings.hide_rejected_and_expired_responses')}
        />
        <SettingsForm.ToggleField
          fieldName="hidePendingResponses"
          label={I18n.t('dashboards.widget_archetypes.crew_confirmations.settings.hide_pending_responses')}
        />
        <SettingsForm.ToggleField
          fieldName="showAvailabilityAtIncidentCreation"
          label={I18n.t(
            'dashboards.widget_archetypes.crew_confirmations.settings.show_availability_at_incident_creation'
          )}
        />
        <SettingsForm.ToggleField
          fieldName="showSeatAllocation"
          label={I18n.t('dashboards.widget_archetypes.crew_confirmations.settings.show_seat_allocation')}
        />
        <SettingsForm.ToggleField
          fieldName="showNicknameInsteadOfFullName"
          label={I18n.t('dashboards.widget_archetypes.crew_confirmations.settings.show_nickname_instead_of_full_name')}
        />
      </SettingsForm.Section.Content>
    </SettingsForm.Section>
  </SettingsForm>
);

export default Settings;
